/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-26 11:03:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-28 14:29:23
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SortableTree/tools.ts
 */
import _ from 'lodash';
const getPath = (tree, id) => {
  return tree.reduce((pre, now, index) => {
    if (now.id == id) {
      return [...pre, index]; //也可以改成[index]
    } else {
      if (now.children && now.children.length > 0) {
        const temp = getPath(now.children, id);

        if ((temp.length || []) > 0) {
          return [index, ...temp]; //temp是子类里面的路径，然后index加上自己的
        } else {
          return pre;
        }
      } else {
        return pre;
      }
    }
  }, []);
};
const getNodes = (tree) => {
  return (tree || []).reduce((pre, now) => {
    if (now.children) {
      const data = [...pre, now];
      const children = getNodes(now.children || []);
      return [...data, ...children];
    } else {
      return [...pre, now];
    }
  }, []);
};
const addNode = (tree, isChild, path, node) => {
  const temp = _.cloneDeep(tree);
  let target = temp;
  const childrenIndex = path.pop();
  if (childrenIndex === undefined) return;
  path.forEach((i) => {
    const child = target[i];
    if (child) {
      child.expanded = true;
      target = child.children;
    }
  });
  if (isChild) {
    target = target[childrenIndex];
    target.expanded = true;
    if (target.children) {
      target.children.push(node);
    } else {
      target.children = [node];
    }
  } else {
    target.expanded = true;
    target.splice(childrenIndex + 1, 0, node);
  }
  return temp;
};
const modifyNode = (tree, node) => {
  const id = node.id;

  const path = getPath(tree, id);

  const temp = _.cloneDeep(tree);
  let target = temp;
  const targetIndex = path.pop();

  if (targetIndex === undefined) return;
  path.forEach((i) => {
    const child = target[i];
    if (child) {
      target = child.children;
    }
  });
  target.splice(targetIndex, 1, node);

  return temp;
  // this.setState({
  //     menuItems: temp,
  // });
};
const deleteNode = (tree, node) => {
  const id = node.id;
  const path = getPath(tree, id);
  const temp = _.cloneDeep(tree);
  let target = temp;
  const targetIndex = path.pop();
  if (targetIndex === undefined) return tree;
  path.forEach((i) => {
    const child = target[i];
    if (child) {
      target = child.children;
    }
  });
  target.splice(targetIndex, 1);
  //console.log(temp);
  return temp;
};

export { getPath, deleteNode, modifyNode, addNode, getNodes };
